"use client";
import { useEffect } from "react";

export default function ViewCounterComp({ documentId }: { documentId: any }) {
  useEffect(() => {
    const checkDateDifference = () => {
      if (typeof window !== "undefined") {
        const savedDateStr = localStorage.getItem(documentId);
        if (!savedDateStr) {
          return true;
        }

        const savedDate = new Date(savedDateStr);
        const currentDate = new Date();
        const timeDiff = currentDate.getTime() - savedDate.getTime();
        const dayDiff = timeDiff / (1000 * 60 * 60 * 24); // Convert to days

        if (dayDiff > 1) {
          saveDateToLocalStorage();
          return true;
        } else {
          return false;
        }
      }
    };

    const saveDateToLocalStorage = () => {
      const now = new Date().toISOString();
      localStorage.setItem(documentId, now);
    };

    if (checkDateDifference()) {
      fetch(`${process.env.NEXT_PUBLIC_HOST}/api/viewer`, {
        method: "POST",
        body: JSON.stringify({ documentId }),
        headers: { "Content-Type": "application/json" },
      }).then(() => saveDateToLocalStorage());
    }
  }, [documentId]);
  return <></>;
}
